var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.5V4.75C6.91125 4.75 11.25 9.08875 11.25 14.5H14.5C14.5 7.33375 8.66625 1.5 1.5 1.5ZM1.5 6.375V9.625C4.21375 9.625 6.375 11.7863 6.375 14.5H9.625C9.625 10.0312 5.96875 6.375 1.5 6.375ZM1.5 11.25V14.5H4.75C4.75 12.6962 3.2875 11.25 1.5 11.25Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWifi);
export default __webpack_public_path__ + "static/media/icon-wifi.2b685403e63522781a193e1e1235904d.svg";
export { ForwardRef as ReactComponent };